const Success = () => {
  return <div className="-mx-2 -my-12 flex flex-shrink flex-grow flex-col sm:-mx-6 lg:-mx-8">Your registration has successfully done, it will take some times to active your portal.</div>;
};

export default Success;
